/**
 * created by Alex Xia on 2/9/2023.
 * Description:
 * provides utilities for check iP
 * Updated by Daniel Wang on 3/12/2023, Added common function to open email with local email app or web browser
 * ------ maintenance history ------
 */

export class CommonUtilities {
    /**
     * open local email with needed parameter
     */
    static openLocalEmail(sendTo: string): Window {
        try {
            const mailObj = window.open('mailto:' + sendTo, 'Mail');
            return mailObj;
        } catch (e) {
            console.error('open local email failed. error: ' + e.message);
        }
    }
    /**
     * open office outlook with browser
     * @param sendTo send to email list
     */
    static openOfficeOutlookWithBrowser(sendTo: string): void {
        try {
            window.open('https://outlook.office.com/mail/deeplink/compose?to=' + sendTo);
        } catch (e) {
            console.error('open outlook with browser failed. error: ' + e.message);
        }
    }

    /**
     * check if the ip format is correct.
     * @param m ip
     * @returns result
     */
    static validateIPAddress(ipAddress): boolean {
        const regex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
        if (regex.test(ipAddress)) {
            return (true);
        } else { return false; }
    }
}
